module.exports = __webpack_public_path__ + "img/verizon.cc7be453.svg";